import { learningObjectivesIntro, initialPost, activitiesListIntro, closing, estimated } from './AL00000Sprint00'
import { softwareEngineeringSprint5Link } from '../Activities/ClassProduct'

import { oreillyPlaylistSE, externalLink } from '../DataAndAPIs/Links'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'
import { scrum, productBacklog, sprintPlanning, sprintBacklog, userStory, userStoryTemplate, /* iNVEST, */ done } from '../DataAndAPIs/Links'
import { sprintEndDateWithoutTime } from '../CalendarAndSchedule/SprintDates'

export const al44000Sprint05 = () => {
	const sprint = 5
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescription(sprint-1)}</h5>

		<p>Welcome to sprint {sprint}. It’s time to delivery valuable features to real product that have real customers. We will do this by
		utilizing Agile Software Development Lifecycle (SDLC) Rolls including Scrum Master, Product Owner, and Team Member. We will 
		groom our {productBacklog()} and complete {sprintPlanning()} to deliver our immutable {sprintBacklog()}. We will use {scrum()}, 
		{userStory()}, {userStoryTemplate()}, and {done()}.</p>

		<p>We will also learn about software maintenance and quickly come to understand that since Agile development has us shipping 
		software to customers every few weeks, nearly all of the work we do in scrum is essentially maintenance.</p>

		{learningObjectivesIntro(sprint)}
		<ul style={{ listStyleType: 'square' }}>
			<li>Groom our {productBacklog()} and complete {sprintPlanning()} to create our immutable {sprintBacklog()}</li>
			<li>Set up our development workflow so that supports local development and testing, hosted testing, and production environments</li>
			<li>Explain why change is inevitable for software systems and describe the processes of software evolution</li>
			<li>Understand Software Maintenance and why almost everything we do in Agile is Software Maintenance</li>
		</ul>

		{list44000Sprint05(sprint)}
		{closing(sprint)}
	</div> )
}

export const list44000Sprint05 = (sprint) => {
	const softwareMaintenanceAndSupport = () => { return externalLink('Software Maintenance and Support', 'https://lewiseducation.blob.core.windows.net/software-engineering/software-maintenance-and-support.mp4') }
	
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			<li>Review sprint {sprint} assignments</li>
			<li><em>Submit Lab {sprint} - Planning</em> after completing {softwareEngineeringSprint5Link()} Requirements 0, 1, and 2 and </li>
			<li>Read Chapter 9 of Fox on Software Maintenance</li>
			<li>Review {softwareMaintenanceAndSupport()} lecture</li>
			{initialPost(sprint)}
			<li>Complete {softwareEngineeringSprint5Link()} Requirements 3 and 4 {estimated('6 hours capacity per team member')}</li>
			<li>Within {oreillyPlaylistSE()} scan “Web Development with Node and Express” chapters 5 through 15</li>
			<li><em>Submit all sprint {sprint} assignments by {sprintEndDateWithoutTime(sprint-1)}</em></li>
		</ol>
	</div> )
}

// Certified for SP25 on March 24, 2025


// Toto: Consider updating and enhancing Quiz 5 as it is not very good. 
// Todo: Consider turning Health Insurance Risk Calculator into a sprint project that need to be reviewed in sprint 5. Maybe it could be a backlog? 

// Todo: Add Support and Maintenance lecture video topics to Quiz 5. Are they already there?
// Todo: Consider migrating books (that's going to be challenging)
// Todo: Consider adding funny video https://www.youtube.com/watch?v=Uo3cL4nrGOk
// Todo: Continue to integrate Software Maintenance, Support, and Metrics into all appropriate classes.
// Todo: Consider doing the same thing for testing.
// Todo: Where should mediaatoz/software-engineering/* videos go? Are they already included?

// Review GitHub Organization tutorials:
// https://docs.github.com/en/organizations/collaborating-with-groups-in-organizations/creating-a-new-organization-from-scratch 
// https://www.youtube.com/watch?v=SUu6cmcC-3A
// https://developers.sap.com/tutorials/webide-github-creating-org.html 

// Consider adding back <li>Within {oreillyPlaylistSE()} scan “Essential Scrum” Chapters 1 and 2</li>
// Todo: Update to reflect Zac’s fix (see related announcement). 
// Todo: Move Whatever Happened to Ruby to earlier sprints.
// Todo: Consider moving  some of the Waterfall Project Management video and assignment from Sprint 5 to sprint 3.
// Todo: Consider moving something related to “Dogs, JavaScript & An API 🐶 Fetch, Promises & Async Await” from sprint 4 to sprint 3
// Todo: Review https://www.geeksforgeeks.org/egg-dropping-puzzle-dp-11/
// Todo: Identify where quiz answers originate from. 
// Todo: Fix the end of the Fox Preface video.
// Todo: Review https://docs.github.com/en/repositories/managing-your-repositorys-settings-and-features/managing-repository-settings/managing-teams-and-people-with-access-to-your-repository
// Todo: Consider adding W3C Validator VS code add-in to several classes. 

// Todo: Consider updating and adding the following Architecture videos back into the class:
//	import { architecturePart1, architecturePart2 } from '../DataAndAPIs/Links'
// <li>Complete {architecturePart1()}</li>
// <li>Scan {architecturePart2()}</li>
// Consider adding https://www.youtube.com/watch?v=A-H-xZ5ZXgo
// Todo: Consider adding back in Architecture lecture or removing SQL questions from quiz.
// Todo: Make sure that in sprints 7 & 8 that “individual” lab questions are identified. 
// Todo: Review Zac’s quiz and update quiz 7. 
// Todo: Consider '<li>Within {oreillyPlaylistSE()} search for “Azure Functions” and “Serverless Computing” and document the best resources</li>'










